import Headline2 from 'components/elements/Headline2'
import React, { useContext, useEffect, useState } from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Box } from "@mui/material";
import RoundIconButton1 from 'components/elements/RoundIconButton1';
import CaretDown from 'components/icons/CaretDown';
import Headline4 from 'components/elements/Headline4';
import { AppContext } from 'contexts/AppContext';
import Sales from 'components/blocks/Sales/Sales';
import { callAPI } from 'utils/API';
import { translate } from 'utils/Translate';
import { Link } from 'react-router-dom';
import ButtonMedium4 from 'components/elements/ButtonMedium4';
import { setupUserData } from "utils/setup";
import { Modal, ModalBody, ModalFooter } from "react-bootstrap";
import ButtonMedium1 from "components/elements/ButtonMedium1";
import Headline6 from "components/elements/Headline6";
import { pointsConvertor } from 'utils/general';
import ContentNormal from 'components/elements/ContentNormal';
import CircularIndeterminate from 'components/blocks/progressBar/progressBar';
import ButtonLarge4 from 'components/elements/ButtonLarge4';
import moment from 'moment';

function ActivationSales({ setActivateComplete, activationSalesRef, ...props }) {
  const { styleGuide, langCode, brandData, userData } = useContext(AppContext);
  const [automaticActivationEnabled, setAutomaticActivationEnabled] = useState(userData.enableAutoWalletActivation === 1 ? true : false);
  const activationPointsSectionLabels = brandData.features?.upgraderClubConfigurableLabels && brandData.features.upgraderClubConfigurableLabels[langCode]?.profilePageLabels?.activationPointsSectionLabels
    ? brandData.features.upgraderClubConfigurableLabels[langCode].profilePageLabels.activationPointsSectionLabels : null
  const contextState = useContext(AppContext);
  const [showActivationModal, setShowActivationModal] = useState(false)
  const [sales, setSales] = useState([])
  const [_, setLoading] = useState(false)
  const [selectAll, setSelectAll] = useState(false)
  const [showAutomaticActivationDialog, setShowAutomaticActivationDialog] = useState(false)
  const [salesToActivate, setSalesToActivate] = useState([])

  const showActivatePointsModal = (sales) => {
    setSalesToActivate(sales)
    setShowActivationModal(true)
  }

  const handleAutomaticActivation = (e) => {
    setShowAutomaticActivationDialog(true)
  }

  const activatePoints = async () => {
    const WalletActivationIDs = salesToActivate.map(s => s.WalletActivationID)
    if (WalletActivationIDs.length) {
      const request = await callAPI(`/walletactivation/updateStatusUser`, "POST", { body: { WalletActivationIDs } })
      if (request) {
        setShowActivationModal(false)
        setActivateComplete({ pointBox: true, pointOverview: true, activationOverview: true, activationGraph: true })
        setupUserData(contextState, setLoading)
        fetchWalletActivation()
        setSales(sales.map(sale => sale.checked = false))
      }
    }
  }

  const fetchWalletActivation = async () => {
    const userWalletLines = await callAPI(`/walletactivation/userPool`);
    if (!userWalletLines || !userWalletLines.length) {
      setSales([]);
    } else {
      setSales(userWalletLines)
    }
  }

  const getSelectedPointsBalance = () => {
    return salesToActivate.filter(s => s.status === 'WAITING' || s.status === 'COMPENSATION').reduce((sum, s) => sum + s.walletAmountPoints, 0)
  }

  const getModalContentText = () => {
    const selectedSales = salesToActivate
    const totalPoints = selectedSales.reduce((sum, a) => sum + a.walletAmountPoints, 0)
    if (!selectedSales.length) {
      return `Please select at least one item`
    }else{
      const balanceAmount = getSelectedPointsBalance()
      if(balanceAmount >= 0){
        const compensationPoints = sales.filter(s => s.status === 'COMPENSATION').reduce((sum, a) => sum + a.walletAmountPoints*-1, 0)
        if(totalPoints >= compensationPoints){
          const confirmText = activationPointsSectionLabels?.popupContentText ? activationPointsSectionLabels.popupContentText.replace("{{walletAmountPoints}}", totalPoints).replace("{{totalSales}}", selectedSales.length) :
             `Er du sikker på, at du vil aktivere ${totalPoints} point?`
          return `${confirmText} ${compensationPoints > 0 ? `Bemærk at ${compensationPoints} point ikke vil blive aktiveret, da de udlignes af dine udligningspoint.` : ''}`
        }else{
          return activationPointsSectionLabels?.popupContentTextCompensationNotAllowed ? activationPointsSectionLabels.popupContentTextCompensationNotAllowed :
            `Den valgte sum af point er mindre end summen af dine udligningspoint (${compensationPoints}). Du skal vælge flere point for at kunne aktivere dem.`
        }
      } else {
        return activationPointsSectionLabels?.popupContentTextCompensation ? activationPointsSectionLabels.popupContentTextCompensation :
          `Din sum af point til aktivering er negativ p.g.a. udligningspoint og du kan derfor ikke aktivere flere point.`
      }
    }
  }

  const getSelectAllStatus = (sales) => {
    const checkedSales = sales.filter(s => s.checked === true).length
    const eligibleSales = sales.filter(s => s.status === "WAITING").length
    return eligibleSales && eligibleSales === checkedSales
  }

  useEffect(() => {
    fetchWalletActivation()
  }, [])

  useEffect(() => {
    if (sales.filter(s => s.checked === true).length === sales.filter(s => s.status === "WAITING").length) {
      setSelectAll(true)
    }
    if (!sales.filter(s => s.checked === true).length) {
      setSelectAll(false)
    }
  }, [sales])

  const fiveMonthsAgo = moment().subtract(5, 'months').startOf('month').utc()
  const twoMonthsAgo = moment().subtract(2, 'months').startOf('month').utc()
  const expiringThisMonth = sales.filter(s => s.status === "WAITING" && moment(s.timeInsert) < fiveMonthsAgo) //.reduce((sum, s) => sum + s.walletAmountPoints, 0)
  const expiringInThreeMonths = sales.filter(s => s.status === 'WAITING' && moment(s.timeInsert) < twoMonthsAgo) //.reduce((sum, s) => sum + s.walletAmountPoints, 0)
  const expiringInSixMonths = sales.filter(s => s.status === 'WAITING') //.reduce((sum, s) => sum + s.walletAmountPoints, 0)
  const pointsSuffix = translate("_POINTS_", "point")

  return (
    <>
      <div
        id={props?.id || ""}
        ref={activationSalesRef}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 20,
          marginTop: 50,
        }}
      >
        {brandData && brandData.features && brandData.features.walletActivationText &&
          <div
            dangerouslySetInnerHTML={{ __html: brandData.features.walletActivationText }}
            style={{
              fontFamily: styleGuide.fontFamily,
              fontSize: styleGuide.headline5FontSize,
              fontStyle: 'normal',
              lineHeight: styleGuide.headline3LineHeight,
              color: styleGuide.color7,
              marginTop: 10,
              marginBottom: 15
            }}
          />
        }

        <Accordion
          defaultExpanded={true}
          style={{
            borderRadius: "14px",
            overflow: "hidden",
            boxShadow:
              "0px 0px 1px 1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
          }}
        >
          <AccordionSummary
            expandIcon={<RoundIconButton1 icon={<CaretDown fill="white" />} />}
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "row",
              padding: "30px 30px 30px 20px",
            }}
          >
            <div style={{ flexDirection: 'column' }}>
              <Headline4
                configuredLabel={activationPointsSectionLabels?.sectionBoxTitleText}
                translationKey="_PROFILE_PAGE_POINT_APPROVAL_CAPTION_"
                fallbackText="Point til aktivering"
                style={{ padding: "30px 20px" }}
              />
              <div style={{display: 'flex', marginLeft: 20, marginTop: 16, gap: 10}}>
                <ButtonMedium4 showIcon={false}
                  onClick={(e) => {
                    e.stopPropagation()
                    setSales(sales.map(sale => {
                      if (sale.status === "WAITING") {
                        sale.checked = !selectAll
                      }
                      return sale
                    }))
                    setSelectAll(!selectAll)
                  }}
                  style={{
                    backgroundColor: getSelectAllStatus(sales) ? styleGuide.color16 : styleGuide.color1,
                    color: getSelectAllStatus(sales) ? styleGuide.color1 : styleGuide.color18
                  }}
                  translationKey="_PROFILE_MULTIPLE_ACTIVATE_BUTTON_"
                  fallbackText="Markér alle"
                />
                {!brandData?.features?.disableAutoActivateFeature && (automaticActivationEnabled
                  ?
                    <ButtonMedium4 showIcon={false}
                      onClick={(e) => {
                        e.stopPropagation()
                        handleAutomaticActivation()
                      }}
                      translationKey="_ENABLE_AUTOMATIC_ACTIVATION_"
                      fallbackText="Tilmeld automatisk aktivering"
                    />
                  :
                    <ButtonMedium4 showIcon={false}
                      onClick={(e) => {
                        e.stopPropagation()
                        handleAutomaticActivation()
                      }}
                      translationKey="_DISABLE_AUTOMATIC_ACTIVATION_"
                      fallbackText="Afmeld automatisk aktivering"
                    />
                  )
                }
                <Link to={'/activationDetails'} target="_blank"
                  style={{
                    textAlign: "center",
                    cursor: "pointer",
                    fontSize: 14, fontFamily: styleGuide.secondaryFontFamily
                  }}>
                  <i>{activationPointsSectionLabels?.automaticActivationLinkText ? activationPointsSectionLabels.automaticActivationLinkText : translate('_WHAT_DOES_THIS_MEAN_', 'Hvad betyder dette?')}</i>
                </Link>
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails
            style={{
              padding: "30px",
              borderTop: `1px solid ${styleGuide.color4}`,
              overflow: 'scroll'
            }}
            className="hide-scroll"
          >
            <Sales setActivateComplete={setActivateComplete} sales={sales} setSales={setSales} refreshData={fetchWalletActivation} setShowModal={() => showActivatePointsModal(sales.filter(s => !!s.checked))} />
          </AccordionDetails>
        </Accordion>

        <Accordion
          defaultExpanded={true}
          style={{
            borderRadius: "14px",
            overflow: "hidden",
            boxShadow:
              "0px 0px 1px 1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
          }}
        >
          <AccordionSummary
            expandIcon={<RoundIconButton1 icon={<CaretDown fill="white" />} />}
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "row",
              padding: "30px 30px 30px 20px",
            }}
          >
            <div style={{ flexDirection: 'column' }}>
              <Headline4
                fallbackText="Overblik over point til udløb"
                style={{ padding: "30px 20px" }}
              />
              <div style={{display: 'flex', marginLeft: 20, marginTop: 16, gap: 10}}>
                <ButtonMedium4 showIcon={false}
                  onClick={(e) => {}}
                  translationKey="_PROFILE_MULTIPLE_ACTIVATE_BUTTON_"
                />
                {!brandData?.features?.disableAutoActivateFeature && (automaticActivationEnabled
                  ?
                    <ButtonMedium4 showIcon={false}
                      onClick={(e) => {
                        e.stopPropagation()
                        handleAutomaticActivation()
                      }}
                      translationKey="_PROFILE_MULTIPLE_ACTIVATE_BUTTON_"
                      fallbackText="Tilmeld automatisk aktivering"
                    />
                  :
                    <ButtonMedium4 showIcon={false}
                      onClick={(e) => {
                        e.stopPropagation()
                        handleAutomaticActivation()
                      }}
                      translationKey="_PROFILE_MULTIPLE_ACTIVATE_BUTTON_"
                      fallbackText="Afmeld automatisk aktivering"
                    />
                  )
                }
                <Link to={'/activationDetails'} target="_blank"
                  style={{
                    textAlign: "center",
                    cursor: "pointer",
                    fontSize: 14, fontFamily: styleGuide.secondaryFontFamily
                  }}>
                  <i>{activationPointsSectionLabels?.automaticActivationLinkText ? activationPointsSectionLabels.automaticActivationLinkText : translate('_WHAT_DOES_THIS_MEAN_', 'Hvad betyder dette?')}</i>
                </Link>
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails
            style={{
              padding: "30px",
              borderTop: `1px solid ${styleGuide.color4}`,
              overflow: 'scroll'
            }}
            className="hide-scroll"
          >
            <Box display={'flex'} flexDirection={'column'} gap={4}>
              <ContentNormal>
                <span style={{fontWeight: 600}}>{`Point udløber 6 mdr. efter de er tildelt`}</span>
                <br />
                {`Point udløber 6 mdr. efter de er blevet tildelt, med mindre du aktiverer dem.`}
                <br />
                {`Aktiverede point er tilgængelige så længe du er medlem af ${brandData.brandName}.`}
              </ContentNormal>
            </Box>
            <Box display={'flex'} gap={4} marginTop={4}>
              <PointOverviewBox
                headline={'Udløber denne måned'}
                points={pointsConvertor(brandData, expiringThisMonth.reduce((sum, s) => sum + s.walletAmountPoints, 0), pointsSuffix)}
                buttonText={translate("_ACTIVATE_POINTS_", "Aktivér point")}
                buttonFunction={() => showActivatePointsModal(expiringThisMonth)}
                textColor={styleGuide.color12}
                loading={false}
              />

              <PointOverviewBox
                headline={'Udløber inden for tre måneder'}
                points={pointsConvertor(brandData, expiringInThreeMonths.reduce((sum, s) => sum + s.walletAmountPoints, 0), pointsSuffix)}
                buttonText={translate("_ACTIVATE_POINTS_", "Aktivér point")}
                buttonFunction={() => showActivatePointsModal(expiringInThreeMonths)}
                textColor={styleGuide.color7}
                loading={false}
              />

              <PointOverviewBox
                headline={'Udløber inden for seks måneder'}
                points={pointsConvertor(brandData, expiringInSixMonths.reduce((sum, s) => sum + s.walletAmountPoints, 0), pointsSuffix)}
                buttonText={translate("_ACTIVATE_POINTS_", "Aktivér point")}
                buttonFunction={() => showActivatePointsModal(expiringInSixMonths)}
                textColor={styleGuide.color7}
                loading={false}
              />
            </Box>
          </AccordionDetails>
        </Accordion>

        <Modal
          show={showActivationModal}
          onHide={() => setShowActivationModal(false)}
          style={{ margin: "auto" }}
          centered
        >
          <Modal.Header
            className="pb-0 border-0"
            closeButton
            style={{ fontSize: 9 }}
          >
            <Headline6 translationKey="_CONFIRM_ACTIVATE_SALES_HEADING_">
              {activationPointsSectionLabels?.popupTitleText ? activationPointsSectionLabels.popupTitleText : 'Bekræft aktivering'}
            </Headline6>
          </Modal.Header>
          <Modal.Body className="pt-0">
            <ContentNormal style={{ whiteSpace: "pre-line" }} translationKey="_CONFIRM_ACTIVATE_SALES_TEXT_">
              {getModalContentText()}
            </ContentNormal>
          </Modal.Body>
          <Modal.Footer>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10
              }}
            >
              {getSelectedPointsBalance() >= 0 && !!salesToActivate.length && (salesToActivate.reduce((sum, a) => sum + a.walletAmountPoints, 0) >= sales.filter(s => s.status === 'COMPENSATION').reduce((sum, a) => sum + a.walletAmountPoints * -1, 0)) &&
                <ButtonMedium1
                  showIcon={false}
                  translationKey="_YES_"
                  fallbackText="Ja"
                  onClick={() => activatePoints()}
                />
              }
              <ButtonMedium4
                showIcon={false}
                translationKey="_CLOSE_"
                fallbackText="Fortryd"
                onClick={() => {
                  setSales(sales.map(s => {
                    s.checked = false
                    return s
                  }))
                  setShowActivationModal(false)
                }}
              />
            </div>
          </Modal.Footer>
        </Modal>

        <ConfirmAutomaticActivationDialog
          open={showAutomaticActivationDialog}
          setOpen={setShowAutomaticActivationDialog}
          activate={automaticActivationEnabled}
          setActivate={setAutomaticActivationEnabled}
        />
      </div>
    </>
  )
}

export const ConfirmAutomaticActivationDialog = (props) => {
  const { activate, setActivate, open, setOpen } = props;
  const { userData, setUserData } = useContext(AppContext);

  const handleClose = () => {
    setOpen(false);
  }

  const handleAgree = async () => {
    let response = await callAPI("/user/toggleAutoWalletActivation", "POST");
    if (response) {
      setUserData({ ...userData, enableAutoWalletActivation: userData.enableAutoWalletActivation === 1 ? 0 : 1 })
      setActivate(!activate)
    }

    setOpen(false);
  }

  return (
    <div>
      <Modal
        show={open}
        onClose={handleClose}
        style={{ margin: "auto" }}
        centered
      >
        <ModalBody>
          <ContentNormal>
            {activate
              ? translate('_MANUAL_ACTIVATION_OF_SALES_', 'Vil du ændre din indstilling til manuel aktivering af dine point?')
              : translate('_AUTOMATIC_ACTIVATION_OF_SALES_', 'Vil du aktivere alle point automatisk? Bemærk at aktiverede point indberettes til Skattestyrelsen')
            }
          </ContentNormal>
        </ModalBody>
        <ModalFooter>
          <ButtonMedium1 showIcon={false} translationKey="_ACCEPT_" fallbackText="Godkend" onClick={handleAgree} />
          <ButtonMedium4 showIcon={false} translationKey="_CANCEL_" fallbackText="Afvis" onClick={handleClose} />
        </ModalFooter>
      </Modal>
    </div>
  );
};


export default ActivationSales

const PointOverviewBox = (props) => {
    return (
        <Box flex={2} style={{ backgroundColor: '#efefef', borderRadius: 14 }} padding={4}>
            <Box display={'flex'} flexDirection={'column'} gap={4}>
                <ContentNormal style={{ textAlign: 'center' }}>
                    {props.headline}
                </ContentNormal>

                <Headline2 style={{ textAlign: 'center', color: props.textColor }}>
                    {props.loading
                        ? 
                            <Box display={'flex'} justifyContent={'center'}>
                                <CircularIndeterminate />
                            </Box>
                        :
                            props.points
                    }
                </Headline2>

                <Box display={'flex'} justifyContent={'center'}>
                    <ButtonLarge4
                        // style={{ width: 80, marginLeft: 'auto', marginRight: 'auto' }}
                        showIcon={false}
                        onClick={props.buttonFunction}
                    >
                        {props.buttonText}
                    </ButtonLarge4>
                </Box>
            </Box>
        </Box>
    )
}